module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Niederdorf_BL-89f22ec42bd976beabaf5d1986432a29.svg";